import {
  CalendarIcon,
  DashboardIcon,
  ExerciceIcon,
  MessageIcon,
  SearchIcon,
  WishIcon,
} from '@myjobglasses/dsm';
import { signout } from '../../../../../actions/signout';
import Routes from '../../../../../routes';
import { numberOfMissingInformationInProfileSelector } from '../../../../../selectors/profile';
import { t } from '../../../../../utils/translate';
import { isAffiliatedToAssignment } from '../../../../../utils/typed/profile';
import { getUserMainProfile } from '../../../../../utils/user';
import { HeaderConfigItem } from '../../@types/HeaderConfig';
import MainMenuItem from '../../components/main-menu-item/MainMenuItem';
import UsernavItem from '../../components/usernav-item/UsernavItem';
import translations from './student.translations';

const config: { main: HeaderConfigItem[], connected: HeaderConfigItem[] } = {
  main: [
    {
      component: MainMenuItem,
      type: 'link',
      key: 'search',
      className: 'main-menu-item-link-blue',
      to: Routes.search,
      label: t(translations.search),
      icon: SearchIcon,
      risingEdge: ({ currentUser }) => {
        if (!currentUser) {
          return false;
        }
        const currentProfile = getUserMainProfile(currentUser);
        return (
          currentProfile?.profileCompletion?.fieldsets?.base?.completionPercentage || 0
        ) >= 100;
      },
      faillingEdge: ({ currentRoute }) => currentRoute === Routes.search,
    },
    {
      component: MainMenuItem,
      type: 'link',
      key: 'dashboard',
      to: Routes.dashboard,
      label: t(translations.dashboard),
      icon: DashboardIcon,
    },
    {
      component: MainMenuItem,
      type: 'link',
      key: 'assignments',
      to: Routes.assignments,
      label: t(translations.assignments),
      icon: ExerciceIcon,
      condition: ({ currentUser }) => isAffiliatedToAssignment(currentUser),
    },
    {
      component: MainMenuItem,
      type: 'link',
      key: 'wishlist',
      to: Routes.studentWishlist,
      label: t(translations.favorites),
      icon: WishIcon,
    },
    {
      component: MainMenuItem,
      type: 'link',
      key: 'conversations',
      to: Routes.conversations,
      label: t(translations.conversations),
      icon: MessageIcon,
      notificationKey: 'unreadMessageCount',
    },
    {
      component: MainMenuItem,
      type: 'link',
      key: 'appointments',
      to: Routes.appointments,
      label: t(translations.appointments),
      icon: CalendarIcon,
    },
  ],
  connected: [
    {
      component: UsernavItem,
      type: 'link',
      key: 'profile',
      to: Routes.profile,
      label: t(translations.profile),
      isNotificationSelector: numberOfMissingInformationInProfileSelector,
    },
    {
      component: UsernavItem,
      type: 'link',
      key: 'settings',
      to: Routes.settings,
      label: t(translations.settings),
    },
    {
      component: UsernavItem,
      type: 'action',
      key: 'logout',
      onClick: (dispatch) => { dispatch(signout(Routes.home)); },
      label: t(translations.logout),
    },
  ],
};

export default config;
